import React from "react";
import Dot from "../assets/Dot.svg";
import ServicesBg from "../assets/img/serviceBg.png";
import Selection from "../assets/img/selection.png";
import Consultation from "../assets/img/consultation.png";
import Accommodation from "../assets/img/accommodation.png";
import Application from "../assets/img/application.png";
import Briefing from "../assets/img/briefing.png";
import Scholarship from "../assets/img/scholarship.png";
import Tutoring from "../assets/img/tutoring.png";
import VisaSupport from "../assets/img/visaSupport.png";

const services = [
  {
    id: 1,
    title: "Consultation and Counseling",
    description1:
      "Individualized sessions to align school choices with academic and career goals.",
    description2:
      "Support with emotional and logistical challenges of studying abroad.",
    img: Consultation,
    url: "/application",
  },
  {
    id: 2,
    title: "School Selection",
    description1:
      "Guidance on factors like entry requirements, career alignment, location, ranking, tuition, and scholarships.",
    description2:
      "A personalized approach ensures choices meet students’ academic and lifestyle preferences.",
    img: Selection,
    url: "/application",
  },
  {
    id: 3,
    title: "Application Assistance",
    description1:
      "Expert help in preparing and submitting applications, including personal statements and required documentation.",
    description2:
      "Focus on accuracy, timeliness, and showcasing student strengths.",
    img: Application,
    url: "/application",
  },
  {
    id: 4,
    title: "Admission and Visa Support",
    description1:
      "Mock interviews and tips on body language, attire, and cultural norms.",
    description2:
      "Step-by-step guidance for visa applications, document preparation, and medical test booking.",
    img: VisaSupport,
    url: "/application",
  },
  {
    id: 5,
    title: "Accommodation Assistance",
    description1:
      "Help finding safe, budget-friendly housing on or off-campus.",
    description2:
      "Insights into local neighborhoods, amenities, and transportation.",
    img: Accommodation,
    url: "/application",
  },
  {
    id: 6,
    title: "Financial Aid and Scholarships",
    description1:
      "Identification and application support for scholarships and financial aid.",
    description2:
      "Assistance with crafting compelling applications and securing recommendations.",
    img: Scholarship,
    url: "/application",
  },
  {
    id: 7,
    title: "Pre-Departure Briefing",
    description1:
      "Cultural adaptation tips, travel logistics, and integration strategies.",
    description2: "Practical advice for academic and social success abroad.",
    img: Briefing,
    url: "/application",
  },
  {
    id: 8,
    title: "Tutoring and Test Preparation",
    description1:
      "Customized study plans for tests like IELTS, SAT, GRE, and more.",
    description2: "Access to practice resources and test-taking strategies.",
    img: Tutoring,
    url: "/application",
  },
];

function Services() {
  return (
    <div className="min-h-screen px-4 container mx-auto">
      <div className="block bg-white h-[130px]"></div>
      <div className="container mx-auto">
        <div className="relative w-full h-[200px] md:h-[280px] overflow-hidden group rounded-3xl">
          <img
            src={ServicesBg}
            alt="Background"
            className="w-full h-full object-cover rounded-3xl transition-transform duration-500 group-hover:scale-110"
          />

          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-white text-4xl md:text-6xl font-bold text-center">
              Our Services
            </h1>
          </div>
        </div>

        <div className="text-center mt-20 container ">
          <h1 className="text-4xl font-bold capitalize text-primary leading-snug">
            We provide high quality{" "}
            <span className="text-secondary">
              educational <br />
              solutions
            </span>
          </h1>
          <p className="opacity-80 md:w-3/5 mx-auto mt-6">
            At 365 Global Consulting, we provide personalized, comprehensive
            support to ensure a seamless transition for students into their
            chosen institutions.
          </p>
        </div>

        <div className="mt-24">
          <div className="flex flex-wrap justify-evenly">
            {services.map((service) => (
              <div key={service.id} className="max-w-[490px] mb-20">
                <div className="relative overflow-hidden group rounded-3xl">
                  <img
                    src={service.img}
                    alt="365 services"
                    className="max-h-[460px] object-cover rounded-3xl transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <h3 className="text-primary font-bold text-3xl py-5">
                  {service.title}
                </h3>
                <div className="flex gap-3 items-start">
                  <img src={Dot} alt="dot" />
                  <p className="opacity-60">{service.description1}</p>
                </div>
                <div className="flex gap-3 items-start mt-4">
                  <img src={Dot} alt="dot" />
                  <p className="opacity-60">{service.description2}</p>
                </div>
                <div className="mt-8">
                  <a
                    href="/application"
                    className="uppercase text-white bg-secondary py-3 px-8 rounded-full hover:bg-gray-cool duration-500"
                  >
                    start application
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
